export default __webpack_public_path__ + "static/media/playtube.56e140b3.png";